// store/index.js

import Vue from "vue";
import Vuex from "vuex";
import { axios_get } from "./../services/vt_service";
import { tracking } from "./../services/tracking";
import { trafo, scv, h2 } from "./../services/powerdata";
import { user, settings } from "./../services/common";
import { fn } from "./../services/utility";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    selected_customer: "lakeland",
    show_nav_bar: true,
    show_right_nav_bar: false,
    page_title: "Home",
    loader: false,
    isProcessing: false,
    showMessage: false,
    message: "",
    search_key: "",
    sections: [],
    user_config: {},
    tenant_config: {},
    devices: null,
    locations: null,
    language: ["EN", "GA", "FR", "ES", "PL"].includes(localStorage.getItem("language"))
      ? localStorage.getItem("language")
      : localStorage.setItem("language", "EN"),
    showLanguage: false,
    darkMode: null,
    powerdata_type: null,
    initial_lat: process.env.VUE_APP_INITIAL_LAT,
    initial_lng: process.env.VUE_APP_INITIAL_LNG,
    initial_map_zoom: process.env.VUE_APP_INITIAL_MAP_ZOOM,
    current_device: null,
    update_alerts: false,
    tags: null,
    tags_list: null,
    is_pq_enabeled: false,
  },
  getters: {
    allSections: (state) => state.sections,
    getPowerDataType: (state) => state.powerdata_type,
    getInitialLatLng: (state) => ({ lat: parseFloat(state.initial_lat), lng: parseFloat(state.initial_lng) }),
    getInitialMapZoom: (state) => parseInt(state.initial_map_zoom),
  },
  mutations: {
    set_customer(val) {
      (state) => (state.selected_customer = val);
    },
    update_page_title(state, val) {
      state.page_title = val;
    },
    toggle_nav_bar(state) {
      state.show_nav_bar = !state.show_nav_bar;
    },
    toggle_right_nav_bar(state) {
      state.show_right_nav_bar = !state.show_right_nav_bar;
    },
    show_loader(state) {
      state.loader = true;
    },
    hide_loader(state) {
      state.loader = false;
    },
    show_label(state) {
      state.isProcessing = true;
    },
    hide_label(state) {
      state.isProcessing = false;
    },
    show_message(state) {
      state.showMessage = true;
    },
    hide_message(state) {
      state.showMessage = false;
    },
    update_message(state, msg) {
      state.message = msg;
    },
    clear_message(state) {
      state.message = null;
    },
    clear_search(state) {
      state.search_key = "";
    },
    set_sections(state, sections) {
      state.sections = sections;
    },
    set_is_pq_enabeled(state, is_pq_enabeled) {
      state.is_pq_enabeled = is_pq_enabeled;
    },
    set_devices(state, devices) {
      state.devices = devices;
    },
    set_locations(state, locations) {
      state.locations = locations;
    },
    set_tags(state, tags) {
      state.tags = tags;
    },
    set_tags_list(state, tags_list) {
      state.tags_list = tags_list;
    },
    update_config(state, config) {
      state.user_config = config;
    },
    set_tenant_settings(state, config) {
      state.tenant_config = config;
    },
    set_language(state, language) {
      state.language = language;
      localStorage.setItem("language", language);
    },
    set_show_language(state, showLanguage) {
      state.showLanguage = showLanguage;
    },
    set_dark_mode(state, darkMode) {
      state.darkMode = darkMode;
      localStorage.setItem("darkMode", darkMode);
    },
    setPowerdataType(state, powerdataType) {
      state.powerdata_type = powerdataType;
    },
    setCurrentDevice(state, device) {
      state.current_device = device;
    },
    setUpdateAlerts(state, update) {
      state.update_alerts = update;
    },
  },
  actions: {
    show_language_feature({ commit }) {
      commit("set_show_language", true);
    },
    show_loader({ commit }) {
      commit("show_loader");
    },
    hide_loader({ commit }) {
      commit("hide_loader");
    },
    show_label({ commit }) {
      commit("show_label");
    },
    hide_label({ commit }) {
      commit("hide_label");
    },
    show_message({ commit }) {
      commit("show_message");
    },
    hide_message({ commit }) {
      commit("hide_message");
    },
    update_message({ commit }, payload) {
      commit("update_message", payload.msg);
    },
    clear_message({ commit }) {
      commit("clear_message");
    },
    update_config({ commit }, payload) {
      commit("update_config", payload.data || {});
    },
    async update_config_settings({ commit }) {
      try {
        const response = await axios_get(user.get_user_config);
        commit("update_config", response);
      } catch (error) {
        console.log(error);
      }
    },
    async loadDevices({ commit }) {
      try {
        const response = await axios_get(tracking.get_device_list);
        commit("set_devices", response);
      } catch (error) {
        console.log(error);
      }
    },
    async loadLocations({ commit }) {
      try {
        const location_res = await axios_get(tracking.get_location_data);
        const stats_res = await axios_get(tracking.get_location_stats);
        const watchlist_res = await axios_get(tracking.get_watchlisted_locations);
        const location_data = fn.merge_locations_obj(location_res, stats_res, watchlist_res);
        commit("set_locations", location_data);
      } catch (error) {
        console.log(error);
      }
    },
    async loadAssets({ commit }) {
      try {
        const response = await axios_get(trafo.get_assets_data, { num_days: 1 });
        commit("set_devices", response);
      } catch (error) {
        console.log(error);
      }
    },
    async loadScvDevices({ commit }) {
      try {
        const response = await axios_get(scv.get_scavenger_list);
        commit("set_devices", response);
      } catch (error) {
        console.log(error);
      }
    },
    async loadScvTags({ commit }) {
      try {
        const response = await axios_get(scv.get_scavenger_tags);
        let tags_list = response[0] || {};
        commit("set_tags", tags_list);
        let tags_count = {};
        Object.values(tags_list).map((tags) =>
          tags.map((tag) => {
            tags_count[tag] = tags_count[tag] ? tags_count[tag] + 1 : 1;
          })
        );
        let sorted_tags = Object.keys(tags_count).sort(function (a, b) {
          return tags_count[b] - tags_count[a];
        });
        commit("set_tags_list", Array.from(sorted_tags));
      } catch (error) {
        console.log(error);
      }
    },
    async loadH2Devices({ commit, state }) {
      try {
        const h2_response = await axios_get(h2.get_scv_h2_assets);
        const pq_response = state.is_pq_enabeled ? await axios_get(scv.get_scavenger_list) : [];
        let res = h2_response.map((item, i) => Object.assign({}, item, pq_response[i]));
        commit("set_devices", res);
      } catch (error) {
        console.log(error);
      }
    },
    initializeTheme({ commit }) {
      const localTheme = localStorage.getItem("darkMode");
      const systemTheme = window.matchMedia("(prefers-color-scheme: dark)").matches;
      commit("set_dark_mode", localTheme !== null ? localTheme === "true" : systemTheme);
    },
    async fetchPowerdataType({ commit }) {
      try {
        const response = await axios_get(settings.get_tenant_config);
        fn.update_tenant(response);
        commit("setPowerdataType", response.powerdata_type);
      } catch (error) {
        console.error("Error fetching powerdata type:", error);
      }
    },
  },
});
